"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    checkoutPackage: {
        url: "/packages/{pid}/checkout",
        method: "POST",
    },
    subscribePlan: {
        url: "/plans/{planId}/subscribe",
        method: "POST",
    },
    sendInquiry: {
        url: "/inquiry",
        method: "POST",
    },
};
//# sourceMappingURL=services.js.map